import { FC } from 'react';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';
import { TradingFormField } from '../../trading-form-field';

type MacdFieldsProps = {
  path: IndicatorIndexedPath;
};

export const MacdFields: FC<MacdFieldsProps> = ({ path }) => (
  <>
    <TradingFormField
      type="numeric"
      name={`${path}.fastPeriod`}
      label="Fast Period"
    />
    <TradingFormField
      type="numeric"
      name={`${path}.slowPeriod`}
      label="Slow Period"
    />
    <TradingFormField
      type="numeric"
      name={`${path}.signalPeriod`}
      label="Signal Period"
    />
  </>
);
